// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll('.mm-shop-category__columns').forEach(function(columnGroup) {
    
//     const linkItems = [];
//     columnGroup.querySelectorAll('ul').forEach(linkList => {
//       linkList.querySelectorAll('li').forEach(linkItem => {
//         linkItems.push(linkItem);
//       });
//     });


//     linkItems.sort((firstItem, secondItem) => {
//       const firstLinkLabel = firstItem.querySelector('a')?.textContent.trim().toUpperCase() || '';
//       const secondLinkLabel = secondItem.querySelector('a')?.textContent.trim().toUpperCase() || '';
//       return firstLinkLabel.localeCompare(secondLinkLabel, undefined, { numeric: true, sensitivity: 'base' });
//     });

//     const columnLists = Array.from(columnGroup.querySelectorAll('ul'));
//     const columnsCount = columnLists.length;
//     const itemsPerColumn = Math.floor(linkItems.length / columnsCount);
//     const extraItems = linkItems.length % columnsCount;
//     let currentIndex = 0;

//     columnLists.forEach(linkList => linkList.innerHTML = '');


//     columnLists.forEach((linkList, columnIndex) => {
//       const thisColumnCount = itemsPerColumn + (columnIndex < extraItems ? 1 : 0);
//       for (let i = 0; i < thisColumnCount; i++) {
//         if (linkItems[currentIndex]) {
//           linkList.appendChild(linkItems[currentIndex]);
//         }
//         currentIndex++;
//       }
//     });

//   });
// });


(function() {
  let initialized = false;

  function initShopCategoryColumns() {
    if (initialized) return;
    initialized = true;

    document.querySelectorAll('.mm-shop-category__columns').forEach(function(columnGroup) {

      const linkItems = [];
      columnGroup.querySelectorAll('ul').forEach(linkList => {
        linkList.querySelectorAll('li').forEach(linkItem => {
          linkItems.push(linkItem);
        });
      });

      // Sort alphabetically
      linkItems.sort((firstItem, secondItem) => {
        const firstLinkLabel = firstItem.querySelector('a')?.textContent.trim().toUpperCase() || '';
        const secondLinkLabel = secondItem.querySelector('a')?.textContent.trim().toUpperCase() || '';
        return firstLinkLabel.localeCompare(secondLinkLabel, undefined, { numeric: true, sensitivity: 'base' });
      });

      const columnLists = Array.from(columnGroup.querySelectorAll('ul'));
      const columnsCount = columnLists.length;
      const itemsPerColumn = Math.floor(linkItems.length / columnsCount);
      const extraItems = linkItems.length % columnsCount;
      let currentIndex = 0;

      columnLists.forEach(linkList => linkList.innerHTML = '');

      columnLists.forEach((linkList, columnIndex) => {
        const thisColumnCount = itemsPerColumn + (columnIndex < extraItems ? 1 : 0);
        for (let i = 0; i < thisColumnCount; i++) {
          if (linkItems[currentIndex]) {
            linkList.appendChild(linkItems[currentIndex]);
          }
          currentIndex++;
        }
      });
    });

    // Remove interaction listeners after initialization
    document.removeEventListener('mousemove', initShopCategoryColumns);
    document.removeEventListener('touchstart', initShopCategoryColumns);
    document.removeEventListener('scroll', initShopCategoryColumns);
  }

  // Wait for user interaction
  document.addEventListener('mousemove', initShopCategoryColumns);
  document.addEventListener('touchstart', initShopCategoryColumns);
  document.addEventListener('scroll', initShopCategoryColumns);
})();
